<script setup>
import ToggleSwitch from 'dashboard/components-next/switch/Switch.vue';

// Rebuilt inside on the kit's switch row (phase 9.4): the switch first, the words to its right, and what the
// switch turns on under a line. Same props, model and slots as before.
defineProps({
  header: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  compact: {
    type: Boolean,
    default: false,
  },
  hideToggle: {
    type: Boolean,
    default: false,
  },
});

const modelValue = defineModel({ type: Boolean, default: false });
</script>

<template>
  <div
    class="flex flex-col items-start rounded-polaris-lg border border-solid border-polaris-border"
  >
    <div class="flex w-full items-start gap-3 px-4 py-3">
      <template v-if="hideToggle">
        <slot name="hiddenToggle" />
      </template>
      <ToggleSwitch v-else v-model="modelValue" :aria-label="header" />
      <div class="grid min-w-0 flex-1 gap-0.5">
        <span class="type-polaris-label text-polaris-foreground">
          {{ header }}
        </span>
        <span
          v-if="description"
          class="type-polaris-body text-polaris-muted-foreground"
        >
          {{ description }}
        </span>
      </div>
    </div>
    <div
      v-if="$slots.editor"
      class="w-full border-0 border-t border-solid border-polaris-border"
      :class="{ 'p-0': compact, 'px-4 pb-4 pt-2': !compact }"
    >
      <slot name="editor" />
    </div>
  </div>
</template>
